<template>
  <section style="display: inherit">
    <a @click="fnShowModal()" v-b-tooltip.hover title="Create / View message">
      <div v-if="quote.has_messages == 1 && quote.messages_for_vsa == 0">
        <span class="badge bdg-not-proceeding"
          ><i class="las la-envelope-open"></i
        ></span>
      </div>
      <div v-else-if="quote.has_messages == 1 && quote.messages_for_vsa > 0">
        <span class="badge bdg-new"><i class="las la-envelope"></i></span>
      </div>
      <div v-else>
        <span><i class="las la-paper-plane text-primary fs-1100"></i></span>
      </div>
    </a>

    <b-modal ref="userModal" size="lg" hide-footer title="Message Us">
      <div class="d-block p-3">
        <!-- Compose a new message -->
        <div class="row">
          <div class="col-12 text-right">
            <button
              class="btn btn-sm btn-primary"
              @click="isCompose = !isCompose"
              v-b-tooltip.hover
              title="Create a new message"
            >
              <i class="lar la-envelope fs-1000 pl-1"></i>
            </button>
          </div>

          <div class="col-12">
            <div class="row" v-if="isCompose">
              <div class="col-lg-12 col-md-12 col-12">
                <div class="form-group">
                  <label class="" for="subject">Subject</label>
                  <input class="form-control" type="text" v-model="subject" />
                  <div class="invalid-feedback" v-if="errors.subject">
                    {{ errors.subject[0] }}
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-12">
                <div class="form-group">
                  <label class="" for="note">Message</label>
                  <vue-editor v-model="body" :editor-toolbar="customToolbar" />
                  <div class="invalid-feedback" v-if="errors.msgBody">
                    {{ errors.msgBody[0] }}
                  </div>
                </div>
              </div>

              <div class="col-12 text-right">
                <button
                  type="button"
                  class="btn btn-dark btn-sm mr-2"
                  @click="hideModal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  @click="fnSendMsg()"
                  class="btn btn-primary btn-sm"
                >
                  <b-spinner small v-if="loading" class="mr-2"></b-spinner>
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Compose a new message End-->

        <div v-if="msgContentAll.length > 0" class="mt-3">
          <template>
            <div
              class="accordion"
              role="tablist"
              v-if="msgContentAll.length > 0"
            >
              <div v-for="(msgs, index3) in msgContentAll" :key="index3">
                <template>
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button
                        block
                        href="#"
                        v-b-toggle="'accordion-' + index3"
                        variant="warning"
                        class="text-left"
                        @click="fnReadMsg(msgs)"
                        >{{ msgs.subject }} |
                        {{ msgs.updated_at | dateConvertDDMMYYYYTime }}
                        <span v-if="msgs.read_by_vsa > 0" class="text-danger"
                          ><i class="las la-bell"></i
                        ></span>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + index3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="text-right" v-if="msgs.sender_party == 2">
                          <button
                            type="button"
                            @click="fnOpenResponse(index3)"
                            class="btn btn-primary btn-sm"
                            v-b-tooltip.hover
                            title="Reply"
                          >
                            <i class="las la-reply fs-1000"></i>
                          </button>
                        </div>

                        <!-- Reply section -->
                        <div
                          class="row"
                          v-if="openResponse == index3 && openSection"
                        >
                          <div class="col-lg-12 col-md-12 col-12">
                            <div class="form-group">
                              <label class="" for="note">Message</label>
                              <vue-editor
                                v-model="body"
                                :editor-toolbar="customToolbar"
                              />
                              <div
                                class="invalid-feedback"
                                v-if="errors.msgBody"
                              >
                                {{ errors.msgBody[0] }}
                              </div>
                            </div>
                          </div>

                          <div class="col-12 text-right">
                            <button
                              type="button"
                              class="btn btn-dark btn-sm mr-2"
                              @click="hideModal"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              @click="fnReplyMsg(msgs)"
                              class="btn btn-primary btn-sm"
                            >
                              <b-spinner
                                small
                                v-if="loading"
                                class="mr-2"
                              ></b-spinner>
                              Send
                            </button>
                          </div>
                        </div>

                        <!-- List old messages Start-->
                        <div
                          v-for="(item, index4) in msgs.msg_content"
                          :key="index4"
                        >
                          <hr v-if="index4 > 0" />
                          <p class="mb-0 fw-400">Date: {{ item.created_at }}</p>
                          <p class="mb-0 fw-400">
                            Created By: {{ item.created_by }}
                          </p>

                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 1 && item.msg_type == 'new'"
                          >
                            Message
                          </p>
                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 2 && item.msg_type == 'reply'"
                          >
                            Response Message
                          </p>

                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 2 && item.msg_type == 'new'"
                          >
                            Message
                          </p>
                          <p
                            class="mb-0 fw-700"
                            v-if="item.to_msg == 1 && item.msg_type == 'reply'"
                          >
                            Response Message
                          </p>

                          <b-card-text v-html="item.body"></b-card-text>
                        </div>
                        <!-- List old messages End -->
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import * as messageService from '../../services/message.service'
import * as msgService from '../../services/msg.service'
import * as authService from '../../services/auth.service'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'ModalReferDealResponded',
  props: ['quote', 'quoteId'],
  components: {},
  data() {
    return {
      loginUser: {},
      openResponse: 100,
      openSection: false,
      isCompose: false,
      msgContentAll: [],
      errors: {},
      loading: false,

      subject: '',
      body: '',

      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ]
    }
  },
  computed: {
    ...mapGetters(['getAdminQuotePaginateData', 'getAdminQuotePaginate'])
  },
  methods: {
    ...mapActions(['fetchNewMsgs', 'fetchAdminQuotePaginate']),
    fnShowModal() {
      this.fnGetMsgs(this.quoteId)
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },
    // Get Messages
    fnGetMsgs: async function (quoteId) {
      try {
        const res = await msgService.all(quoteId)
        this.msgContentAll = res.data
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Messages',
          'Something wrong on quote status update'
        )
      }
    },
    // Reply Message
    fnReplyMsg: async function (msgs) {
      this.errors = ''
      let msgObj = {}
      msgObj = {
        body: this.body,
        created_at: moment().format('DD-MM-YYYY hh:mm A'),
        created_by: this.loginUser.firstName,
        msg_type: 'reply',
        from_msg: 1,
        to_msg: 2,
        sender_id: this.loginUser.id
      }

      let obj = {
        msgContent: msgObj,
        sender_party: 1
      }
      try {
        this.loading = true
        const res = await msgService.update(msgs.id, obj)

        if (res.status == 200) {
          messageService.fnSweetAlertSuccessToast(
            'Reply message',
            'Send successfully'
          )

          this.fnGetMsgs(this.quoteId)

          this.subject = ''
          this.body = ''
          this.sender_party = ''
          this.openSection = !this.openSection
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Reply message',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Reply message',
              'Something wrong'
            )
            break
        }
      }
      this.loading = false
    },
    fnSendMsg: async function () {
      this.errors = ''
      let msgObj = {}
      msgObj = [
        {
          body: this.body,
          created_at: moment().format('DD-MM-YYYY hh:mm A'),
          created_by: this.loginUser.firstName,
          msg_type: 'new',
          from_msg: 1,
          to_msg: 2,
          sender_id: this.loginUser.id
        }
      ]

      let obj = {
        quoteId: this.quoteId,
        subject: this.subject,
        msgContent: msgObj,
        sender_party: 1
      }
      try {
        this.loading = true
        const res = await msgService.add(obj)

        if (res.status == 200) {
          this.fetchAdminQuotePaginate(this.getAdminQuotePaginate)
          this.hideModal()
          messageService.fnSweetAlertSuccessToast(
            'New message',
            'Send successfully'
          )

          this.subject = ''
          this.notes = ''
          this.sender_party = ''
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'New message',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'New message',
              'Something wrong'
            )
            break
        }
      }

      this.loading = false
    },

    fnOpenResponse(index) {
      this.openResponse = index
      this.openSection = !this.openSection
    },

    // After collapse open that read_by_vsa going to 0, it says that they have read it.
    fnReadMsg(msgs) {
      if (msgs.read_by_vsa == 1) {
        msgService.fnUpdateMsgReadStatus(msgs.id, 'vsa', 0)

        this.fetchAdminQuotePaginate(this.getAdminQuotePaginate)

        // To load new msg
        this.fetchNewMsgs({
          dealerUserId: '',
          reader: 'vsa'
        })
      } else {
        return
      }
    }
  },
  created() {
    this.loginUser = authService.getUserFromToken()
  }
}
</script>